import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendereventService {
  public calendereventSubject = new Subject<any>();

  constructor() { }

  dayClicked(data) {
    this.calendereventSubject.next(data);
  }
}
